<div class="sample-iep-goals-container">
  <h2>Sample IEP Goals</h2>
  <p class="section-subtitle">Add IEP goals samples with instructions</p>

  <div class="iep-bulk-paste">
    <app-button type="primary" layout="outline" size="small" (click)="iepPasteOpen = !iepPasteOpen"> Paste from spreadsheet </app-button>
    @if (iepPasteOpen) {
      <div class="iep-paste-body">
        <p class="iep-paste-helper">Copy two columns from a spreadsheet (title, description) and paste below. Fields will fill in automatically.</p>
        <p class="iep-paste-warning">This will override all fields below.</p>
        <textarea
          placeholder="e.g. Classroom Routine&#10;Learner will navigate familiar classroom routines…&#10;Following Directions&#10;Learner will follow single/multi-step adult verbal/visual directives…"
          rows="5"
          (input)="onBulkPaste($any($event.target).value)"
        ></textarea>
      </div>
    }
  </div>

  <div cdkDropList (cdkDropListDropped)="onDrop($event)">
    @for (item of goals; track $index) {
      <div class="iep-goal-card" cdkDrag>
        <div class="iep-goal-card-header">
          <div class="iep-goal-card-header-content">
            <div class="iep-drag-handle" cdkDragHandle>☰</div>
            <span class="iep-goal-index">{{ $index + 1 }}</span>
          </div>
          @if (goals.length > 1) {
            <app-button type="danger" layout="outline" size="small" (click)="remove($index)"> Remove </app-button>
          }
          @if (goals.length === 1 && (item.title || item.description)) {
            <app-button type="basic" layout="outline" size="small" (click)="clear()"> Clear </app-button>
          }
        </div>
        <div class="iep-goal-fields">
          <div class="iep-goal-field">
            <p class="field-label">Title</p>
            <input type="text" placeholder="e.g. Following Directions" [(ngModel)]="item.title" (ngModelChange)="onFieldChange()" />
          </div>
          <div class="iep-instruction-field">
            <p class="field-label">Description</p>
            <textarea placeholder="" [(ngModel)]="item.description" (ngModelChange)="onFieldChange()" rows="4"></textarea>
          </div>
        </div>
      </div>
    }
  </div>

  <app-button type="primary" size="small" iconUrl="../../../../assets/images/icons/plus.svg" (click)="add()">
    Add another sample IEP goal
  </app-button>
</div>
